import React from 'react'

import { styled } from '../../theme'

interface SpacerProps {
  size?: 'sm' | 'md' | 'lg'
}
interface StyledSpacerProps {
  size: string
}

const StyledSpacer = styled('div')<StyledSpacerProps>`
  height: ${(props) => props.size};
  width: ${(props) => props.size};
`

export const Spacer: React.FC<React.PropsWithChildren<SpacerProps>> = ({ size = 'md' }) => {
  let s: string
  switch (size) {
    case 'lg':
      s = '32px'
      break
    case 'sm':
      s = '12px'
      break
    case 'md':
    default:
      s = '24px'
  }

  return <StyledSpacer data-test-id="spacer" size={s} />
}
